<template>
<div class="view view-topics">
	<div class="view__main">
		<banner
			title="Choose a topic to get started..."
			text="You can then come back and view others."
		/>

		<breadcrumb
			class="breadcrumb--big-banner"
			:to="{ name: $GLOBALS.ROUTE_RECIPIENTS }"
			label="Recipient types"
		/>

		<div class="main-content main-content--short">

			<div class="container">
				<p>Can't find what you're looking for? Use our content search above</p>

				<div class="selection-block-container">
					<selection-block
						v-for="(topic, index) in $store.state.topics"
						:key="index"
						:topic="topic"
					/>
				</div>
			</div>

		</div>
	</div>

</div>
</template>

<script>
// Components
import Banner from '@/components/blocks/Banner.vue';
import Breadcrumb from '@/components/global/Breadcrumb.vue';
import SelectionBlock from '@/components/blocks/SelectionBlock.vue';

export default {
	components: {
		Banner,
		Breadcrumb,
		SelectionBlock
	}
};
</script>
